var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5496 12.5277V17.6843C20.5496 19.5144 19.0659 20.9981 17.2367 20.9981H6.76305C4.93295 20.9981 3.44922 19.5144 3.44922 17.6843V12.5277C3.44922 10.6976 4.93295 9.21484 6.76305 9.21484H17.2367C19.0659 9.21484 20.5496 10.6976 20.5496 12.5277Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18164 6.11169H17.818M8.71945 3H15.281",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2252 12.3936L12.9597 13.8715C12.9967 13.9462 13.0678 13.998 13.1495 14.0095L14.7943 14.2476C14.8611 14.2564 14.9209 14.2915 14.9622 14.3442C15.0386 14.4435 15.0272 14.5858 14.9349 14.6719L13.7435 15.8238C13.6829 15.881 13.6556 15.9644 13.6714 16.0461L13.957 17.6725C13.9772 17.8078 13.885 17.9335 13.7496 17.9554C13.6943 17.9642 13.6372 17.9554 13.5862 17.9299L12.1215 17.1629C12.0486 17.1225 11.9599 17.1225 11.8869 17.1629L10.4108 17.9343C10.2878 17.9967 10.1367 17.951 10.0699 17.8298C10.0444 17.7814 10.0348 17.7252 10.0435 17.6716L10.3291 16.0453C10.3432 15.9635 10.3168 15.881 10.2579 15.823L9.05947 14.6711C8.96195 14.5735 8.96195 14.4154 9.05947 14.3179C9.09989 14.281 9.1491 14.2572 9.20269 14.2476L10.8475 14.0086C10.9301 13.9963 11.0004 13.9444 11.0382 13.8698L11.7718 12.3936C11.8008 12.3339 11.8535 12.2873 11.9168 12.2662C11.9809 12.246 12.0504 12.2504 12.1101 12.2812C12.1593 12.3049 12.1997 12.3444 12.2252 12.3936Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavDocument);
export default __webpack_public_path__ + "static/media/FavDocument.772328714cc4c03fe38a6192236c5af9.svg";
export { ForwardRef as ReactComponent };